/**
 * Theme hook for accessing current theme
 */

import { useContext, createContext } from 'react';
import { ThemeConfig } from '../config/types';

const ThemeContext = createContext<ThemeConfig | null>(null);

export function ThemeProvider({
  theme,
  children,
}: {
  theme: ThemeConfig;
  children: React.ReactNode;
}) {
  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme(): ThemeConfig {
  const theme = useContext(ThemeContext);
  if (!theme) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return theme;
}
